import $http from "../axios";

const state = {
  credits: []
};

const getters = {
  credits(state) {
    return state.credits;
  },
  creditsReverse(state) {
    return state.credits.reverse();
  }
};

const actions = {
  getCredits({ commit }) {
    return new Promise((resolve, reject) => {
      $http
        .get(`credits`)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_CREDITS", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  findUser(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(`find-user-for-credit?${data.id}=${data.value}`)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  giveCredit(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`give-credit`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  getCreditDetails(_, creditId) {
    return new Promise((resolve, reject) => {
      $http
        .get(`credit-details?creditId=${creditId}`)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_CREDITS(state, payload) {
    state.credits = payload.credits;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
